import React from 'react';
import {Link} from 'react-router-dom'
import {fallbackFestival} from 'lib/festivalConfig';

export default function Logo({festival = fallbackFestival}) {
    return (<>
        <Link to="/dashboard" className="-intro-x hidden md:flex">
            <img alt={festival.name} className="h-10 w-36 object-contain" src={festival.logo}/>
        </Link>
    </>);
}
